export default "__VITE_ASSET__c0b32df5__"